

exports.__esModule = true;
exports.COOKIE_AGE = exports.COOKIE_NAME = exports.AUTH_LINK_HATEOS = exports.VENMO_VERSION = exports.TOKEN_PARAM_NAME = undefined;

var _squid = require('squid');

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _checkout = require('xo-models/src/checkout');

var _index = require('xo-models/src/fi/index');

var _auth = require('xo-models/src/auth');

var _venmoModels = require('xo-third-party-components/src/venmo-models');

var _thirdPartyInfo = require('xo-third-party-components/src/thirdParty-info');

var _uiRouter = require('uiRouter');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TOKEN_PARAM_NAME = exports.TOKEN_PARAM_NAME = 'payload_id';
var VENMO_VERSION = exports.VENMO_VERSION = 'venmo-version';
var AUTH_LINK_HATEOS = exports.AUTH_LINK_HATEOS = 'ot_cookie_link';
var COOKIE_NAME = exports.COOKIE_NAME = 'pwv';
var COOKIE_AGE = exports.COOKIE_AGE = 365 * 4 * 24 * 60 * 60 * 1000;

exports['default'] = _squid.$Component.extend('$VenmoPayloadBootstrap', {
    tag: 'venmo-payload-bootstrap',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            optional: true
        }
    },

    resolve: {
        venmoParams: function venmoParams() {
            var _ref;

            return _ref = {}, _ref[TOKEN_PARAM_NAME] = _uiRouter.$stateParams[TOKEN_PARAM_NAME], _ref[AUTH_LINK_HATEOS] = _uiRouter.$stateParams[AUTH_LINK_HATEOS], _ref;
        },
        venmoAppVersion: function venmoAppVersion() {
            var _ref2;

            return _ref2 = {}, _ref2[VENMO_VERSION] = _uiRouter.$stateParams[VENMO_VERSION], _ref2;
        },
        checkoutCart: function checkoutCart() {
            return _checkout.$CheckoutCartModel.instance(this.token).retrieve();
        },
        checkoutPayee: function checkoutPayee() {
            return _checkout.$CheckoutPayeeModel.instance(this.token).retrieve();
        },
        appData: function appData() {
            return _checkout.$CheckoutAppDataModel.instance(this.token).retrieve();
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            _logger.$logger.info(['xo-venmo directive', 'lifecycle', 'enter'].join('::'));

            this.done = function (shippingAddress) {

                // usecase 1: the billing address of the venmo user existed
                // usecase 2: the checkbox was displayed on the shipping address form and the venmo user checked it
                // usecase 3: the checkbox was displayed on the shipping address form and the venmo user did not check it -> go to billing page

                if (!_this.renderBillingAddCheckbox) {
                    // usecase 1
                    _this.goto('checkout.review');
                } else if (shippingAddress) {
                    // usecase 2

                    // Transform shipping address into billing address : format
                    var add = {
                        newAddress: {
                            address1: shippingAddress.line1,
                            address2: shippingAddress.line2,
                            city: shippingAddress.city,
                            state: shippingAddress.state,
                            zip: shippingAddress.postal_code,
                            isoCountry: shippingAddress.country
                        }
                    };
                    var billingAddress = new _index.$AddBillingAddressModel({ instrumentid: _this.instrumentID });
                    var self = _this;
                    billingAddress.save({
                        data: add,
                        success: function success() {
                            _logger.$logger.info(['xo-venmo directive', 'Billing Address', 'added'].join('::'));

                            // Fix to mitigate the symphony issue with POSTAL CODE MISSING
                            // Need to have a better solution
                            _logger.$logger.info(['xo-venmo directive', 'Calling checkout session again'].join('::'));

                            var sessionModel = _checkout.$CheckoutSessionModel.instance(self.token);
                            var cartModel = _checkout.$CheckoutCartModel.instance(self.token);
                            var venmoOnboardModel = _venmoModels.$VenmoOnboardModel.instance(self.token);

                            sessionModel.action('create', {
                                data: {
                                    fraudnet_id: cartModel.supplementary && cartModel.supplementary.risk_correlation_id,
                                    baToken: cartModel.billing && cartModel.billing.ba_token,
                                    user_selected_funding_source: {
                                        dcvv: venmoOnboardModel.dcvv,
                                        product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                                    },
                                    is_skip_gfo: true
                                },
                                success: function success() {
                                    _uiRouter.$state.go('checkout.review');
                                }
                            });
                        },
                        error: function error(err) {
                            _logger.$logger.error('billingAddressSaveError', err);
                            _uiRouter.$state.go('checkout.login', { venmoError: true });
                        },
                        validation: function validation(_validation) {
                            _logger.$logger.error('billingAddressValidationError', _validation);
                            _uiRouter.$state.go('checkout.login', { venmoError: true });
                        }
                    });
                } else {
                    // usecase 3
                    _this.goto('checkout.venmo.addBilling');
                }
            };
        },
        populate: function populate() {
            var _this2 = this;

            (0, _jquery2['default'])('#preloaderSpinner').show();
            var venmoParams = this.venmoParams,
                venmoAppVersion = this.venmoAppVersion,
                checkoutCart = this.checkoutCart,
                checkoutPayee = this.checkoutPayee,
                appData = this.appData;
            var ot_cookie_link = venmoParams.ot_cookie_link;


            if (ot_cookie_link) {
                _logger.$logger.info('venmo_ot_cookie_link_landing', { authLink: venmoParams[AUTH_LINK_HATEOS] });
                var returnUri = '' + _angular.$location.absUrl().replace(/#.*$/, '');

                var params = (0, _angular.$httpParamSerializer)({
                    returnUri: returnUri
                });

                _logger.$logger.info('venmo_new_account_auth_linkback', returnUri);
                _logger.$logger.info('venmo_UL_redirect_to', ot_cookie_link + '&' + params);

                return _squid.$util.redirect(ot_cookie_link + '&' + params, { replace: true }); // append with the returnUri
            }

            // Placeholder to update the value of the venmo cookie with the incoming app version
            this.updateVenmoCookie = function () {
                var appVersion = venmoAppVersion[VENMO_VERSION];
                if (appVersion) {
                    var expires = ';expires=' + new Date(Date.now() + COOKIE_AGE);
                    window.document.cookie = COOKIE_NAME + '=' + appVersion + expires + ';domain=.' + _squid.$meta.domain + ';path=/';
                    _logger.$logger.info('pwv_cookie_updated', appVersion);
                }
            };
            this.updateVenmoCookie();

            var checkoutSessionModel = _checkout.$CheckoutSessionModel.instance(this.token);
            var venmoOnboardModel = _venmoModels.$VenmoOnboardModel.instance(this.token);
            var venmoDcvv = void 0;

            var totalTransaction = checkoutCart && checkoutCart.purchase && checkoutCart.purchase.amounts && checkoutCart.purchase.amounts.total;

            var onboardRequest = {
                payload_id: venmoParams.payload_id,
                limit: {
                    currency: totalTransaction && totalTransaction.currency_code,
                    amount: totalTransaction && totalTransaction.amount
                },
                intent: checkoutCart.payment_action,
                merchant_id: checkoutPayee.merchant.id,
                baToken: checkoutCart.billing && checkoutCart.billing.ba_token
            };

            var facilitatorAccessToken = _squid.$util.param('facilitatorAccessToken');

            if (facilitatorAccessToken) {
                onboardRequest.facilitatorAccessToken = facilitatorAccessToken;
            }

            // define steps
            var onboardMember = function onboardMember() {
                return venmoOnboardModel.save({
                    data: onboardRequest,
                    success: function success(data) {
                        _logger.$logger.info(data);
                        venmoDcvv = data.dcvv;
                        _this2.instrumentID = data.instrument_id;
                        return data;
                    },
                    error: function error(err) {

                        failureHandling('hermesnodeweb', err && err.stack || err);
                    },
                    validation: function validation(_validation2) {
                        return _uiRouter.$state.go('checkout.login', { venmoError: true });
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            failureHandling('hermesnodeweb', contingency && contingency.message);
                        }
                    }
                });
            };

            var setVenmoToken = function setVenmoToken() {
                return _thirdPartyInfo.thirdPartyExperience.setAsVenmoExperience(_this2.token);
            };

            var self = this;
            var createCheckoutSession = function createCheckoutSession() {
                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: checkoutCart.supplementary && checkoutCart.supplementary.risk_correlation_id,
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token,
                        user_selected_funding_source: {
                            dcvv: venmoDcvv,
                            product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                        },
                        is_skip_gfo: true
                    },
                    success: function success(result) {
                        return result;
                    },
                    contingencies: {
                        NEED_SHIPPING_ADDRESS: function NEED_SHIPPING_ADDRESS(msg, contingency) {

                            // In the case the merchant only ships to local country
                            _logger.$logger.info('venmo_shipping_contingency');

                            // If the user hasn't entered a billing address, we'll also take it into consideration.
                            return _index.$BillingAddressesModel.instance().retrieve().then(function (billingAddresses) {

                                self.renderBillingAddCheckbox = !(billingAddresses && billingAddresses.addresses && billingAddresses.addresses['0']);

                                _uiRouter.$state.go('checkout.venmo.addShipping');
                            });
                        },
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('venmo_unhandled_symphony_contingency', msg);
                            failureHandling('paymentapiplatserv', contingency && contingency.message);
                        }
                    }
                });
            };
            var refreshAuthState = function refreshAuthState() {
                var auth = _auth.$AuthModel.instance().reload();
                _squid.$locale.choose(auth.country, auth.language, false);
                return auth;
            };

            var onAuth = function onAuth(authModel) {

                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {

                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
            };

            var routeDecision = function routeDecision(checkoutSession) {

                if (checkoutSession) {

                    _index.$BillingAddressesModel.instance().retrieve().then(function (billingAddresses) {

                        // if the billing address model retrieves an existing address, the addresses array will have a property '0'
                        _this2.renderBillingAddCheckbox = !(billingAddresses && billingAddresses.addresses && billingAddresses.addresses['0']);

                        if (appData && appData.flags && appData.flags.shipping_address_required && !checkoutSession.shipping) {
                            // if shipping is required and no shipping is sent in xo session, we route to shipping address page
                            return _uiRouter.$state.go('checkout.venmo.addShipping');
                        } else if (_this2.renderBillingAddCheckbox) {
                            // shipping address exists, go to billing page
                            return _uiRouter.$state.go('checkout.venmo.addBilling');
                        } else {
                            // else, we go to review page

                            return _uiRouter.$state.go('checkout.review');
                        }
                    });
                } else {
                    _logger.$logger.info('venmo_empty_checkoutSession');
                }
            };

            var failureHandling = function failureHandling(source, err) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'VENMO_ENTRYPOINT',
                    to: 'process_venmo_entrypoint',
                    'int_error_description': 'venmo_onboard_failure',
                    'error_type': 'soft_decline',
                    'error_source': source
                });

                _logger.$logger.error('venmoOnboardingError', err);

                // go back to login with an error param to show the buyer oupon landing
                _uiRouter.$state.go('checkout.login', { venmoError: true });
            };

            onboardMember().then(setVenmoToken).then(refreshAuthState).then(onAuth).then(createCheckoutSession).then(routeDecision)['catch'](function (err) {
                venmoOnboardModel.invalidate();
                if (err instanceof _squid.$Forbidden) {// ignore forbidden errors

                } else {
                    failureHandling('hermesnodeweb', err && err.stack || err);
                }
            });
        },
        exit: function exit() {
            (0, _jquery2['default'])('#preloaderSpinner').hide();
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$Forbidden;

_squid.$util;

_squid.$meta;

_angular.$location;

_angular.$httpParamSerializer;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_index.$AddBillingAddressModel;

_index.$BillingAddressesModel;

_auth.$AuthModel;

_venmoModels.$VenmoOnboardModel;

_thirdPartyInfo.thirdPartyExperience;

_uiRouter.$stateParams;

_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-venmo/directive.js
// module id = ./pages/xo-venmo/directive.js
// module chunks = 0